// extracted by mini-css-extract-plugin
export default {"form":"MealItemForm_form__LcEJs"};